<script>
import toast from '@/utils/toast'
import request from '@/utils/request'
import bus from 'vue3-eventbus'
import http from '@/utils/http'
import lottie from 'lottie-web'
import animationData from '@/assets/share_whatsapp.json'
import features from '@/config/features'

// Android WebView（非 Chrome/系统浏览器）不认 intent:// twitter:// sms: 这类非 http scheme，
// 直接 location.href 过去会报 ERR_UNKNOWN_URL_SCHEME，只能走原生桥或 https
function isAndroidWebviewEnv () {
  const ua = navigator.userAgent || ''
  if (!/android/i.test(ua)) {
    return false
  }
  // 标准 WebView UA 带 "; wv)"；部分厂商去掉了 wv 标记，再用「没有独立浏览器版本号」兜底
  return /;\s*wv\)/i.test(ua) || !/(Chrome|CriOS|EdgA|SamsungBrowser|OPR|Firefox)\/\d+/i.test(ua)
}

// 新 6 图标行里的 X / SMS 都得靠原生 shareKit 拉起 App。
// 老版本 App 的 WebView 没注入 shareKit，这些图标点了没反应，直接降级回旧分享行。
// 纯 web 和 iOS 不受影响（各自有 https / webkit 桥的兜底路径）。
function supportNewShare () {
  if (!isAndroidWebviewEnv()) {
    return true
  }
  return !!(window.shareKit && window.shareKit.share)
}

export default {
  data () {
    return {
      // 分享行版本：false = 旧行(WhatsApp lottie/FB/Instagram/Telegram/More)，true = 新 6 图标行
      // 开关开着也可能被降级：安卓 WebView 里缺 shareKit 时强制回旧行
      newShare: features.newShare && supportNewShare(),
      // 纯 web 分享 YouTube 用：提前把视频 fetch 成 File 缓存，点击时同步 share
      ytVideoFile: null,
      ytVideoPreloading: false
    }
  },
  // YouTube 入口已从分享行移除，暂停视频预加载；恢复入口时放开
  // watch: {
  //   // shareData 通常是异步下发，就绪后触发预加载
  //   '$store.state.shareData': {
  //     immediate: true,
  //     handler () {
  //       this.preloadYoutubeVideo()
  //     }
  //   }
  // },
  mounted() {
    // 旧版分享行的 WhatsApp 用 lottie 动画（新 6 图标行是静态图，不需要）
    if (!this.newShare) {
      this.anim = lottie.loadAnimation({
        container: this.$refs.lottieRef,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData
      })
    }
  },
  methods: {
    copyText(text) {
      http.reportEvent("us_copy_click","")
      if (navigator.clipboard) {
        if(window.jskit && window.jskit.showToast){
          window.jskit.showToast('copy success')
        }else{
          toast.show('copy share link success')
        }

        return navigator.clipboard.writeText(text)
      } else {
        return this.fallbackCopy(text)
      }
    },
    fallbackCopy(text) {
      const textarea = document.createElement('textarea')
      textarea.value = text
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      return Promise.resolve()
    },
    shareWhatsapp () {
      http.reportEvent("us_whatsapp_click","")
      this.$store.commit('shareTip', false)
      const whatsApp = this.getShareDataByPkg('com.whatsapp')
      if (!whatsApp) {
        return
      }
      this.reportShare('WA')
      setTimeout(() => {
        bus.emit('refresh', true)
      }, 2000)
      if (window.jskit && window.jskit.share) {
        if(window.jskit.startPortraitPage){
          window.jskit.share('com.whatsapp', JSON.stringify(whatsApp))
        }else{
          window.jskit.share('com.whatsapp', whatsApp.link)
        }

        window.jskit.showToast('Share Success')
        return
      }
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.share) {
        window.webkit.messageHandlers.share.postMessage({
          platform: 'com.whatsapp',
          link: whatsApp.link
        })
        return
      }
      let _href = 'https://api.whatsapp.com/send?'
      const text = whatsApp.link
      const link = whatsApp.img
      _href += '&text=' + encodeURIComponent(text)
      _href += '&img=' + encodeURIComponent(link)
      window.open(_href)
    },
    sharaFB () {
      http.reportEvent("us_facebook_click","")
      this.$store.commit('shareTip', false)
      const fb = this.getShareDataByPkg('com.facebook.katana')
      if (!fb) {
        return
      }
      this.reportShare('FB')
      if (window.jskit && window.jskit.share) {
        if(window.jskit.startPortraitPage){
          window.jskit.share('com.facebook.katana', JSON.stringify(fb))
        }else{
          window.jskit.share('com.facebook.katana', fb.link)
        }
        // window.jskit.showToast('Share Success')
        return
      }
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.share) {
        window.webkit.messageHandlers.share.postMessage({
          platform: 'com.facebook.katana',
          link: fb.link
        })
        return
      }
      const _href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(fb.link)
      window.open(_href)
    },
    // 是否在 App 的 WebView 里（有原生分享桥）
    hasNativeShare () {
      return !!(window.jskit && window.jskit.share) ||
        !!(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.share)
    },
    isAndroidWebview () {
      return isAndroidWebviewEnv()
    },

    shareX () {
      http.reportEvent("us_x_click","")
      this.$store.commit('shareTip', false)
      const shareData = this.getShareDataOrDefault('com.twitter.android')
      if (!shareData) {
        return
      }
      this.reportShare('X')
      // App 内：交给原生 startActivity 拉起 X，WebView 自己跳 scheme 会 ERR_UNKNOWN_URL_SCHEME
      if (window.jskit && window.jskit.share) {
        if (window.shareKit.share) {
          window.shareKit.share('com.twitter.android', JSON.stringify(shareData))
        } else {
          window.jskit.share('com.twitter.android', shareData.link)
        }
        return
      }
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.share) {
        window.webkit.messageHandlers.share.postMessage({
          platform: 'com.twitter.android',
          link: shareData.link
        })
        return
      }
      this.openXApp(shareData.link)
    },

    // 纯 web 拉起 X App：优先 scheme，拉不起来再回落网页版
    openXApp (text) {
      const webUrl = 'https://x.com/intent/post?text=' + encodeURIComponent(text)
      const ua = navigator.userAgent || ''

      if (/android/i.test(ua)) {
        // 无桥的第三方 WebView：不支持 intent://，只能直接开 https 网页版
        if (this.isAndroidWebview()) {
          window.location.href = webUrl
          return
        }
        // Chrome 的 intent: 语法：装了 X 直接进 App，没装则自动跳 browser_fallback_url
        window.location.href = 'intent://post?message=' + encodeURIComponent(text) +
          '#Intent;scheme=twitter;package=com.twitter.android;S.browser_fallback_url=' +
          encodeURIComponent(webUrl) + ';end'
        return
      }

      if (/iphone|ipad|ipod/i.test(ua)) {
        this.openIosSchemeOrWeb('twitter://post?message=' + encodeURIComponent(text), webUrl)
        return
      }

      window.open(webUrl)
    },

    // iOS 无法探测 App 是否安装：先试 scheme，若页面没被切到后台说明没拉起来，再开网页版
    openIosSchemeOrWeb (scheme, webUrl) {
      const abort = () => {
        clearTimeout(timer)
        document.removeEventListener('visibilitychange', onHide)
        window.removeEventListener('pagehide', abort)
      }
      const onHide = () => {
        // 页面进入后台 = App 已被拉起，取消回落
        if (document.hidden) {
          abort()
        }
      }
      const timer = setTimeout(() => {
        abort()
        window.location.href = webUrl
      }, 1200)
      document.addEventListener('visibilitychange', onHide)
      window.addEventListener('pagehide', abort)
      window.location.href = scheme
    },

    shareSms () {
      http.reportEvent("us_sms_click","")
      this.$store.commit('shareTip', false)
      const shareData = this.getShareDataOrDefault('sms')
      if (!shareData) {
        return
      }
      this.reportShare('SMS')
      // App 内：WebView 不认 sms: scheme（ERR_UNKNOWN_URL_SCHEME），走原生系统分享面板，用户在面板里选短信。
      // 后续原生若提供专门的短信入口，这里换成对应 platform 即可。
      if (window.jskit && window.jskit.share) {
        if (window.shareKit.share) {
          window.shareKit.share('sms', JSON.stringify(shareData))
        } else {
          window.jskit.share('', shareData.link)
        }
        return
      }
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.share) {
        window.webkit.messageHandlers.share.postMessage({
          platform: '',
          link: shareData.link
        })
        return
      }
      // 无桥的第三方 Android WebView 同样拉不起 sms:，退化为系统分享 / 复制链接
      if (this.isAndroidWebview()) {
        if (navigator.share) {
          navigator.share({ title: 'Share', text: shareData.link }).catch(() => {})
        } else {
          this.copyText(shareData.link)
          toast.show('Link copied, please paste it in Messages')
        }
        return
      }
      // 纯 web：用 sms: scheme 唤起系统短信，'?&body=' 同时兼容 iOS / Android
      window.location.href = 'sms:?&body=' + encodeURIComponent(shareData.link)
    },

    // 新设计已下线 Telegram 入口，方法保留以便后续恢复
    shareTelegram () {
      http.reportEvent("us_telegram_click","")
      this.$store.commit('shareTip', false)
      const shareData = this.getShareDataByPkg('org.telegram.messenger')
      if (!shareData) {
        return
      }
      this.reportShare('Tel')
      if (window.jskit && window.jskit.share) {
        if(window.jskit.startPortraitPage){
          window.jskit.share('org.telegram.messenger', JSON.stringify(shareData))
        }else{
          window.jskit.share('org.telegram.messenger', shareData.link)
        }
        window.jskit.showToast('Share Success')
        return
      }
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.share) {
        window.webkit.messageHandlers.share.postMessage({
          platform: 'org.telegram.messenger',
          link: shareData.link
        })
        return
      }
      let _href = 'https://t.me/share/url?'
      const text = shareData.link
      const link = shareData.img
      _href += '&text=' + encodeURIComponent(text)
      _href += '&url=' + encodeURIComponent(link)
      window.open(_href)
    },

    shareToIns () {
      http.reportEvent("us_ins_click","")
      this.$store.commit('shareTip', false)
      const shareData = this.getShareDataByPkg('com.instagram.android')
      if (!shareData) {
        return
      }
      // 安卓 WebView 专用 Instagram 分享方法，优先
      if (window.jskit && window.jskit.shareToInstagramApp) {
        this.reportShare('Ins')
        window.jskit.shareToInstagramApp(shareData.link)
        return
      }
      this.copyText(shareData.link)
      this.reportShare('Ins')
      if (window.jskit && window.jskit.share) {
        if(window.jskit.startPortraitPage){
          window.jskit.share('com.instagram.android', JSON.stringify(shareData))
        }else{
          window.jskit.share('', shareData.link)
        }
        // window.jskit.showToast('Share Success')
        return
      }
      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.share) {
        window.webkit.messageHandlers.share.postMessage({
          platform: 'com.instagram.android',
          link: shareData.link
        })
        return
      }

      const value = shareData.link
      if (navigator.clipboard !== undefined && navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(value)
        if(window.jskit && window.jskit.share){
          window.jskit.showToast('copy success')
        }
      } else {
        this.copy2(value)
      }

      let _href = 'https://www.instagram.com/?'
      // const text = shareData.link
      // const link = shareData.img
      // _href += '&text=' + encodeURIComponent(text)
      // _href += '&url=' + encodeURIComponent(link)
      window.open(_href)
    },



    shareSystem () {
      http.reportEvent("us_more_click","")
      this.$store.commit('shareTip', false)
      const shareData = this.getShareDataByPkg('default')
      if (!shareData) {
        return
      }
      this.reportShare('other')

      if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.share) {
        window.webkit.messageHandlers.share.postMessage({
          platform: '',
          link: shareData.link
        })
        return
      }
      if (window.jskit && window.jskit.share) {
        if(window.jskit.startPortraitPage){
          window.jskit.share('system', JSON.stringify(shareData))
        }else{
          window.jskit.share('', shareData.link)
        }
        window.jskit.showToast('Share Success')
        return
      }
      if (navigator.canShare) {
        navigator.share({
          title: 'Share',
          text: shareData.link
        })
      } else {
        toast.show('Your browser does not support sharing')
      }
    },
    getShareDataByPkg (pkg) {
      const shareData = this.$store.state.shareData
      for (const index in shareData) {
        const item = shareData[index]
        if (item.platform === pkg) {
          return item
        }
      }
    },
    // 新增平台后端可能尚未下发对应 platform，取不到时回落到 default，保证按钮可用
    getShareDataOrDefault (pkg) {
      return this.getShareDataByPkg(pkg) || this.getShareDataByPkg('default')
    },
    copyTxt () {
      const value = this.$store.state.linkUrl
      if (navigator.clipboard !== undefined && navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(value)
        if(window.jskit && window.jskit.showToast){
          window.jskit.showToast('copy success')
          return;
        }
        toast.show('copy success')
      } else {
        this.copy2(value)
      }
    },
    reportShare (platform) {
        // 这些参数在 store 里（appConfig/登录时写入），组件没 mapState，之前用 this.xxx 全是 undefined
        const s = this.$store.state
        const requestBody = {
          pn: s.pn,
          aid: s.aid,
          pkg: s.pkg,
          uid: s.uid,
          code: s.code,
          channel: s.channel,
          region: 'US',
          channelid: s.channel,
          platform: platform,
          shareId: ""
        }
        http.postHttp(`/landscape/region/taskV2/share?code=${s.code}&pn=${s.pn}&platform=${platform}&platform=${platform}&shareId=${''}&region=${'US'}`, requestBody)
          .then((resp) => {
            bus.emit('refresh', true)
          })
    },

    copy2 (value) {
      const textArea = document.createElement('textarea')
      textArea.value = value
      // textArea.focus()
      textArea.style.position = 'fixed'
      textArea.style.opacity = '0'
      document.body.appendChild(textArea)
      textArea.select()
      /* eslint-disable no-new */
      new Promise(() => {
        document.execCommand('copy')
        // textArea.remove()
        document.body.removeChild(textArea)
        if(window.jskit && window.jskit.showToast){
          window.jskit.showToast('copy success')
          return;
        }
        toast.show('copy success')
      })
    }
  }
}
</script>

<template>
  <div class="share-bg">
  <div class="shimmer">
    <div id="share_top">
      <img src="../assets/share_gift.png">
      <div id="share_link">
        <span>Link:</span>
        <span>{{ $store.state.linkUrl }}</span>
        <div id="btn_copy" @click="copyTxt"></div>
      </div>
    </div>
    <!-- 新版 6 图标行：SMS / Facebook / WhatsApp / Instagram / X / More -->
    <div id="share_items" class="items-new" v-if="newShare">
      <div class="share_item iv_sms" @click="shareSms"></div>
      <div class="share_item iv_fb" @click="sharaFB"></div>
      <div class="share_item iv_whatsapp" @click="shareWhatsapp"></div>
      <div class="share_item iv_ins" @click="shareToIns"></div>
      <div class="share_item iv_x" @click="shareX"></div>
      <div class="share_item iv_system" @click="shareSystem"></div>
      <!-- <div class="share_item iv_youtube" @click="shareyoutube"></div> -->
    </div>
    <!-- 旧版分享行（WhatsApp lottie / Facebook / Instagram / Telegram / More） -->
    <div id="share_items" class="items-old" v-else>
      <div ref="lottieRef" class="iv_whatsapp" @click="shareWhatsapp"></div>
      <div class="iv_fb" @click="sharaFB"></div>
      <div class="iv_ins" @click="shareToIns"></div>
      <div class="iv_telegram" @click="shareTelegram"></div>
      <div class="iv_system" @click="shareSystem"></div>
      <!-- <div class="tips" v-show="$store.state.finish_task_count == 0">
        <div>$ 5</div>
      </div> -->
    </div>
    <!-- <div ref="coinRef" class="share-outline"></div> -->
  </div>
  </div>
</template>

<style scoped>

.share-bg {
  width: 100%;
  height: 26.2rem;
  background-image: url("../assets/share_bg.png");
  background-position: center;
  justify-items: center;
  display: flex;
  position: relative;
  flex-direction: column;
  background-size: 100% 100%;
  overflow: hidden;
}

.shimmer {
  width: 100%;
  height: 26.2rem;
  background-position: center;
  padding: 0 1rem;
  justify-items: center;
  display: flex;
  position: relative;
  flex-direction: column;
  background-size: 100% 100%;
  overflow: hidden;
  border-radius: 16px;
}

/* 扫光层 */
.shimmer::after {
  content: "";
  position: absolute;
  top: 0;
  left: -150%;
  width: 50%;
  height: 100%;

  background: linear-gradient(
    90deg,
    transparent,
    rgba(255,255,255,0.6),
    transparent
  );

  animation: shine 5s infinite;
}

@keyframes shine {
  100% {
    left: 150%;
  }
}

#share_top {
  height: 13.2rem;
  display: flex;
  align-items: center;
}

#share_top > img {
  height: 11rem;
  width: 48.3rem;
}

#share_link {
  background-image: url("../assets/bg_share_link.png");
  background-size: cover;
  height: 6rem;
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 1rem;
  padding: 0 1rem 0 2.4rem;
}


#share_top > div :first-child {
  color: rgba(255, 255, 255);
  font-size: 2.4rem;
}

#share_top > div :nth-child(2) {
  color: rgb(255, 255, 255);
  padding-left: 1rem;
  font-size: 2.2rem;
  flex: 1;
}

#btn_copy {
  background-image: url("../assets/iv_copy.png");
  background-size: cover;
  display: flex;
  align-content: center;
  justify-content: center;
  height: 5.3rem;
  width: 11rem;
  border-radius: 0.6rem;
}

#btn_copy:active {
  opacity: 0.6;
}

#btn_copy > p {
  align-self: center;
  color: rgb(255, 255, 255);
  font-size: 2.8rem;
}

#share_items {
  width: 100%;
  height: 13rem;
  align-items: center;
  display: flex;
}

/* ===== 新版 6 图标行 ===== */
.items-new {
  justify-content: space-between;
  /* 左右各留 0.4rem，压缩 space-between 的可分配余量，让按钮更贴近 */
  padding: 0 0.4rem;
  /* 整组上移 */
  margin-top: -1rem;
}

/* 6 个分享按钮，图标源尺寸 156x129，等比铺满 */
.items-new .share_item {
  flex: none;
  width: 14.5rem;
  height: 12rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.items-new .share_item:active {
  opacity: 0.6;
}
.items-new .iv_whatsapp { background-image: url("@/assets/ic_share_wa.png"); }
.items-new .iv_fb { background-image: url("@/assets/ic_share_fb.png"); }
.items-new .iv_ins { background-image: url("@/assets/ic_share_ins.png"); }
.items-new .iv_x { background-image: url("@/assets/ic_share_x.png"); }
.items-new .iv_sms { background-image: url("@/assets/ic_share_sms.png"); }
.items-new .iv_system { background-image: url("@/assets/ic_share_more.png"); }

/* ===== 旧版分享行（WhatsApp lottie / Telegram / Facebook / Instagram / More） ===== */
.items-old .iv_whatsapp {
  width: 34.5rem;
  height: 12.7rem;
  margin-bottom: 1rem;
}
.items-old .iv_whatsapp:active { opacity: 0.6; }
.items-old .iv_fb {
  width: 20.3rem;
  height: 12.7rem;
  background-image: url("@/assets/share_fb.png");
  background-size: contain;
  background-repeat: no-repeat;
}
.items-old .iv_fb:active { opacity: 0.6; }
.items-old .iv_telegram {
  width: 20.7rem;
  height: 12.7rem;
  background-image: url("@/assets/share_telegram.png");
  background-size: contain;
  background-repeat: no-repeat;
}
.items-old .iv_telegram:active { opacity: 0.6; }
.items-old .iv_ins {
  width: 20.3rem;
  height: 12.7rem;
  background-image: url("@/assets/share_ins.png");
  background-size: contain;
  background-repeat: no-repeat;
}
.items-old .iv_ins:active { opacity: 0.6; }
.items-old .iv_system {
  width: 12.3rem;
  height: 12.7rem;
  background-image: url("@/assets/share_more.png");
  background-size: contain;
  background-repeat: no-repeat;
}
.items-old .iv_system:active { opacity: 0.6; }

.tips {
  position: absolute;
  height: 6.5rem;
  width: 12rem;
  left: 23rem;
  bottom: 8rem;
  background: url("@/assets/share_red_tip.png");
  background-size: 100% 100%;
}

.tips div {
  position: absolute;
  font-size: 2.4rem;
  left: 4.6rem;
  color: #FBEB6E;
  font-weight: bolder;
  top: 1.1rem;
  text-shadow: 0.2rem 0.2rem 0 #77271C, 0.2rem 0.2rem 0 #77271C, 0.2rem 0.2rem 0 #77271C, 0.2rem 0.2rem 0 #77271C;

}

/* @media screen and (orientation: portrait) {
  .share-outline {
    height: 100vw;
    width: 169vw;
    background-image: url("@/assets/main_share_outline.png");
    background-size: 100% 100%;
    position: absolute;
    pointer-events: none;
    bottom: 0;
    left: -1%;
  }
}

@media screen and (orientation: landscape) {
  .share-outline {
    width: 169vh;
    height: 95vh;
    background-image: url("@/assets/main_share_outline.png");
    background-size: 100% 100%;
    position: absolute;
    pointer-events: none;
    bottom: 0;
    left: -1%;
  }
} */

.share-outline {
  width: 102%;
  height: 100%;
  background-image: url("@/assets/main_share_outline.png");
  background-size: 100% 100%;
  position: absolute;
  pointer-events: none;
  bottom: 0;
  left: -1%;
  z-index: 10;
}
</style>
